import React, { useMemo } from 'react';
import { HStack, Icon, Text } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { RiQuestionnaireFill } from 'react-icons/ri';

import colors from '../../../../styles/colors';
import { QuestionOnReviewT, QuestionType } from './ReviewQuestion.types';
import AnswerRenderer from '../../../messaging/seeker/candidate/documentUploadQuestions/components/AnswerRenderer';
import { normaliseAnswers } from '../../../messaging/seeker/candidate/documentUploadQuestions/documentRenderer.types';

export const ReviewDocumentUpload = React.memo(function ReviewDocumentUpload({ question }: { question: QuestionOnReviewT }) {
  const { t } = useTranslation();

  // Memoize the normalised file list — normaliseAnswers() only reruns when
  // question.answers changes, not on every parent re-render.
  const answerFiles = useMemo(() => {
    if (question.type !== QuestionType.DOCUMENT_UPLOAD) return [];
    const rawAnswers = Array.isArray(question.answers) ? question.answers : /* istanbul ignore next */ [];
    return normaliseAnswers(rawAnswers);
  }, [question.type, question.answers]);

  if (question.type !== QuestionType.DOCUMENT_UPLOAD) {
    return null;
  }

  if (answerFiles.length === 0) {
    return (
      <HStack spacing={2} mt={1}>
        <Icon as={RiQuestionnaireFill} color="orange.400" />
        <Text fontSize="sm" fontWeight="bold" color={colors.text.dark}>
          {t('documentUploadQuestions.skipped')}
        </Text>
      </HStack>
    );
  }

  return <AnswerRenderer answers={answerFiles} maxItemsPerRow={3} />;
});
